import EditarSubstrato from "../../../components/Cadastros/Editar/EditarSubstrato";
import Header from "../../../components/Menu";

const EditarSubstratoPage = () => {
  return (
    <div className="flex">
      <Header />
      <EditarSubstrato />
    </div>
  );
};

export default EditarSubstratoPage;
